import { motion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { MagneticButton } from "./MagneticButton";
import { WA_LINKS } from "../lib/utils";
import { Reveal } from "./Reveal";

export function CTABanner() {
  return (
    <section className="relative overflow-hidden bg-navy-800 py-32 noise-overlay">
      <motion.div
        animate={{ scale: [1, 1.1, 1], opacity: [0.08, 0.14, 0.08] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-emerald-400 blur-[100px]" />

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-px bg-gradient-to-r from-transparent via-gold-400/60 to-transparent" />

      <div className="container-luxury relative text-center">
        <Reveal><p className="eyebrow text-emerald-300 mb-6">Ready to Begin?</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mx-auto max-w-3xl font-sans text-display-md font-semibold text-white tracking-tight text-balance leading-tight">
            Your property deserves{" "}
            <span className="font-display italic font-normal text-gold-300">expert attention.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-white/65 text-balance leading-relaxed">Get your free Property Health Check today, our team will assess your asset, share a transparent report, and recommend the right management plan for you.

          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <MagneticButton href={WA_LINKS.healthCheck} external size="lg" variant="primary" icon={<MessageCircle size={18} />} data-testid="cta-health-check">Get Free Property Health Check</MagneticButton>
            <MagneticButton href={WA_LINKS.call} external size="lg" variant="ghost" className="border-white/25 text-white hover:border-white/50" icon={<ArrowRight size={18} />} data-testid="cta-book-call">Book a 15-min Call</MagneticButton>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-8 text-xs text-white/40 tracking-wide">No commitment required · Free initial consultation · Trusted by NRIs in 12+ countries</p>
        </Reveal>
      </div>
    </section>);

}